import { render, staticRenderFns } from "./SisProgrammeLearningGroup.vue?vue&type=template&id=79c2b5d6&"
import script from "./SisProgrammeLearningGroup.vue?vue&type=script&lang=ts&"
export * from "./SisProgrammeLearningGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SisProgrammeLearningGroup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports